import { twMerge } from "tailwind-merge";
import { IconsProps } from ".";

export const CreditCard = ({
  className = "text-primary",
  viewBox = "0 0 29 24",
  width = 29,
  height = 24,
  onClick,
}: IconsProps) => (
  <svg
    className={twMerge("cursor-pointer", className)}
    viewBox={viewBox}
    width={`${width}px`}
    height={`${height}px`}
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <title>Card</title>
    <path
      d="M25.625 0.666992H2.95833C1.38583 0.666992 0.139167 1.92783 0.139167 3.50033L0.125 20.5003C0.125 22.0728 1.38583 23.3337 2.95833 23.3337H25.625C27.1975 23.3337 28.4583 22.0728 28.4583 20.5003V3.50033C28.4583 1.92783 27.1975 0.666992 25.625 0.666992ZM25.625 20.5003H2.95833V12.0003H25.625V20.5003ZM25.625 6.33366H2.95833V3.50033H25.625V6.33366Z"
      fill="currentColor"
    />
  </svg>
);
